export function getBaseUrl() {
  let env = {}
  try {
    env = import.meta.env
    if (typeof env !== 'object') env = {}
  } catch {
    env = {}
  }

  return env.VITE_VUE_APP_BASE_URL ?? ''
}
